import { EntDepartment } from "./department";
import { EntGovernment } from "./government";

export class EntPositions {
  id: number = 0;
  nameRu: string = "";
  nameKy: string = "";
  government?: EntGovernment | null = null;
  department?: EntDepartment | null = null;
  departmentId: EntDepartment | null = null;
  parentId?: number | null = null;
}
